import { Status, Toggletip } from './kit'
import { personasWithScreen } from '../lib/api'
import '../styles/persona.css'

// The screen somebody sees when they open a screen that belongs to another
// persona's job: one heading, who does own it, one way back.
//
// It is not a refusal of the roles. The routes behind the screen answer exactly
// as the person's roles allow; this is the console keeping one account to one
// job, which is the founder's rule (15 September 2026). So it says whose job it
// is and sends the person home, rather than reading like an error they caused.
//
// Naming the owner is the persona spec's rule P9 (release 3.1): "This page is
// not part of the <role> role. <owning role> manages it." A reader told only
// that a page is not theirs has to go and find out who to ask.
//
// data-testid="role-refusal" is the hook the persona walk looks for (spec
// section 9.1): a hidden page shows this, never a silent redirect.

export function ownersSentence(owners: string[]): string {
  if (owners.length === 0) return 'No job in this workspace has it on its menu.'
  if (owners.length === 1) return owners[0] + ' manages it.'
  if (owners.length <= 3) return owners.slice(0, -1).join(', ') + ' and ' + owners[owners.length - 1] + ' manage it.'
  return owners.slice(0, 3).join(', ') + ' and ' + (owners.length - 3) + ' other job' + (owners.length - 3 === 1 ? '' : 's') + ' manage it.'
}

export function NotYourJob({ persona, home, screen }: { persona: string; home: string; screen?: string }) {
  const job = persona || 'this account'
  const owners = screen ? personasWithScreen(screen).filter((n) => n !== persona) : []
  return (
    <div className="p1-page">
      <section className="panel nyj" role="status" aria-labelledby="nyj-h" data-testid="role-refusal" data-page-refused={screen ? 'tprm.' + screen : undefined}>
        <Status tone="neutral">Another job</Status>
        <h1 id="nyj-h">This page is not part of your job as {job}</h1>
        {screen && <p className="nyj-line">{ownersSentence(owners)}</p>}
        <p className="nyj-line">
          Your menu shows the screens that are yours.{' '}
          <Toggletip label="Why this screen is not shown">
            One account does one job. If this screen is part of your work, an administrator can give it its own account.
          </Toggletip>
        </p>
        <a className="button primary" href={home}>
          {home === '#/home' ? 'Home' : 'Back to your work'}
        </a>
      </section>
    </div>
  )
}
